import React from "react";

import { useLadyProfileDto } from "@/features/lady-profile/hooks";

import { SliderContextProvider } from "../context/Slider.context";
import { LadySliderV2 } from "./LadySliderV2";
import { ladySliderV2MediaFilter } from "./helpers";

type PropTypes = {
  initialIndex: number;
};

export const LadySliderV2Modal: React.FC<PropTypes> = ({ initialIndex }) => {
  const {
    data,
    clientMutations: { toggleMediaFavorite },
  } = useLadyProfileDto();

  if (!data) return null;

  return (
    <SliderContextProvider
      initialIndex={initialIndex}
      mediaLength={ladySliderV2MediaFilter(data.forms.media).length}
    >
      <LadySliderV2 toggleMediaFavorite={toggleMediaFavorite} data={data} />
    </SliderContextProvider>
  );
};
